/* eslint-disable import/no-unresolved */
// ^ no-unresolved gets triggered by '?react' suffix
import React from "react";
import { Flex, Circle, Icon } from "@chakra-ui/react";
import { AiFillBank } from "react-icons/ai";
import TiliaSvg from "assets/tilia-logo.svg?react";
import DiscoverSvg from "assets/card-logos/discover.svg?react";
import VisaSvg from "assets/card-logos/visa.svg?react";
import AmexSvg from "assets/card-logos/amex.svg?react";
import MasterCardSvg from "assets/card-logos/mastercard.svg?react";
import DinersClubSvg from "assets/card-logos/dinersclub.svg?react";
import JCBSvg from "assets/card-logos/jcb.svg?react";
import CUPSvg from "assets/card-logos/cup.svg?react";
import MaestroSvg from "assets/card-logos/maestro.svg?react";
import PaypalSvg from "assets/paypal-logo.svg?react";
import WalletSvg from "assets/wallet-icon.svg?react";
import SkrillSvg from "assets/skrill-logo.svg?react";

// TODO: not even sure if this style stuff is actually getting applied (which is fine so long as it looks ok)
const cardLogoStyle = {
  height: "25px",
  width: "auto",
};
export const DiscoverLogo = (props) => <DiscoverSvg style={cardLogoStyle} {...props} />;
export const VisaLogo = (props) => <VisaSvg style={cardLogoStyle} {...props} />;
export const AmexLogo = (props) => <AmexSvg style={cardLogoStyle} {...props} />;
export const MasterCardLogo = (props) => <MasterCardSvg style={cardLogoStyle} {...props} />;
export const DinersClubLogo = (props) => <DinersClubSvg style={cardLogoStyle} {...props} />;
export const JCBLogo = (props) => <JCBSvg style={cardLogoStyle} {...props} />;
export const CUPLogo = (props) => <CUPSvg style={cardLogoStyle} {...props} />;
export const MaestroLogo = (props) => <MaestroSvg style={cardLogoStyle} {...props} />;
export const PaypalLogo = (props) => <PaypalSvg style={cardLogoStyle} {...props} />;
export const WalletIcon = (props) => <WalletSvg style={cardLogoStyle} {...props} />;
export const SkrillLogo = (props) => <SkrillSvg style={cardLogoStyle} {...props} />;

/**
 * Renders the Tilia logo
 * @param {Object} props
 * @param {('md'|'sm')} props.size - The size of the logo to be rendered
 */
export const TiliaLogo = ({ size = "md", ...rest }) => {
  let sizing = { width: 80, height: 32 };

  if (size === "sm") {
    sizing = { width: 60, height: 24 };
  }

  return <TiliaSvg {...sizing} {...rest} />;
};

export const GenericBankLogo = () => {
  return (
    <Flex align="center" data-testid="generic-bank-logo">
      <Circle bgColor="integrator.600" border="1px solid" borderColor="integrator.500" p="2">
        <Icon as={AiFillBank} boxSize="5" color="white" />
      </Circle>
    </Flex>
  );
};
